import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DynamicPageModule } from './dynamic/dynamic.module';
import { CardsComponent } from './dynamic/pages/finance-dashboard/cards/cards.component';
import { SharedModule } from './shared/modules/shared/shared.module';
import { tokenGetter } from './shared/services/auth.service';
import { StaticPageModule } from './static/static.module';
import { UpdateOrganizationModule } from './dynamic/pages/manage/organization/update-organization/update-organization.module';


// import { BaseChartDirective } from 'ng2-charts';
// import * as p from 'chartjs-plugin-colorschemes';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [
          '192.168.0.24:5010',
          'localhost:5010',
          'localhost:44335',
          'atsdev.southafricanorth.cloudapp.azure.com:5010',
          'dms.properties:5010'
        ],
      },
    }),
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    StaticPageModule,
    DynamicPageModule,
    SharedModule,
    HttpClientModule,
    UpdateOrganizationModule
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
